<template>
  <div>
    <div class="attachments">
      <div class="attachment-box" v-bind:class="attachmentClassDirectory(file.file_type)" v-for="(file,i) of files" :key="i">
        <div>
          <span class="attachment-box-name">{{ file.file_name }}</span>
          <span class="attachment-box-size">{{ (file.file_size) }} </span>
        </div>
        <a class="attachment-box-remove" @click="removeFile(file)"></a>
      </div>
    </div>
    <div class="attachments">
      <div class="attachment-box" v-bind:class="attachmentClassDirectory(file.file_type)" v-for="(file,i) of gallery" :key="i">
        <div>
          <span class="attachment-box-name">{{ file.file_name }}</span>
          <span class="attachment-box-size">{{ (file.file_size) }} </span>
        </div>
        <a class="attachment-box-remove" @click="removeFile(file)"></a>
      </div>
      <div class="attachment-box loading" v-if="uploadingFile">
        <AttachmentLoader></AttachmentLoader>
        <div>
          <span class="attachment-box-name">Uploading File ...</span>
          <span class="attachment-box-size">0 Kb </span>
        </div>
      </div>
    </div>

    <div class="form-bottom">
      <slot name="cancel"></slot>
      <label for="comment-attachment" class="button-icon button-icon--mobile-image">Attach file <i class="icon-attach"></i></label>
      <input type="file" id="comment-attachment" name="comment-attachment" accept="image/*" ref="file" v-on:change="addFile()">
      <slot name="add"></slot>
    </div>
  </div>
</template>

<script>
import api from '@/api/files'
import settings from "@/settings";
import AttachmentLoader from "@/components/forms/AttachmentLoader";
//import AttachmentLoader from "./Loader/AttachmentLoader";
export default {
  name: "CommentAttachmentsInput",
  components: {AttachmentLoader},
  //components: {AttachmentLoader},
  props: ['files', 'gallery', 'type'],
  data() {
    return {
      uploadingFile: 0,
      imageUrl: `${settings.API_BASE_PATH}/image`
    }
  },
  methods: {
    addFile() {
      Array.from(this.$refs.file.files).forEach(file => {
        this.uploadingFile = this.uploadingFile + 1
        this.uploadingImage = true
        api.addFile(file, (data) => {
          this.uploadingFile = this.uploadingFile - 1
          if(data) {
            this.$emit('addImage', [{
              idFile: data.idFile,
              url: `${this.imageUrl}/${data.idFile}`,
              file_name: data.orgName,
              file_size: data.size,
              file_type: data.type
            }])
          }
        })
      })
    },
    removeFile(file){
      let indexGallery = this.gallery.findIndex((item) => {
          return item.idFile === file.idFile
      })
      this.files.splice(indexGallery, 1)
    },
    attachmentClassDirectory(type) {
      switch (type) {
        case 'image':
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
          return 'attachment-box--pic'
        case 'application/pdf':
        case 'pdf':
          return 'attachment-box--pdf'
        case 'document':
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessing':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'attachment-box--word'
      }
      return 'attachment-box--default'
    }
  }
}
</script>

<style scoped>

</style>
